import { forwardRef } from 'react';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';
import { Label } from './Label';
import { Typography } from './Typography';
import { cx } from 'class-variance-authority';

type ReadOnlyFieldTypeMap = BaseTypeMap<'div', { label: string }>;

export type ReadOnlyFieldProps = ComponentProps<ReadOnlyFieldTypeMap>;

export const ReadOnlyField: Component<ReadOnlyFieldTypeMap> = forwardRef(
  function ReadOnlyField({ children, className, label, ...rest }, ref) {
    return (
      <Box ref={ref} {...rest} className={cx('relative', className)}>
        <Label rise as="p">
          {label}
        </Label>
        <Typography weight="medium">{children}</Typography>
      </Box>
    );
  }
);
